import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import Loader from '../Loader/Loader'

const TableLoaderElement = ({
  colSpan = 8,
  width,
  thickness = 2,
}: {
  colSpan?: number
  width?: string
  thickness?: number
}) => {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={colSpan}>
          <Stack
            paddingY={'60px'}
            justifyContent={'center'}
            direction={'row'}
            width={width}
          >
            <Box sx={{ width: '40px' }}>
              <Loader thickness={thickness} />
            </Box>
          </Stack>
        </TableCell>
      </TableRow>
    </TableBody>
  )
}

export default observer(TableLoaderElement)
